// src/utils/auth.js

export const logoutUser = (navigate = null) => {
  // 1. Clear all auth tokens
  localStorage.removeItem("token");
  localStorage.removeItem("user_token");
  localStorage.removeItem("access_token");
  localStorage.removeItem("user");

  // 2. Redirect to login
  // If we passed the navigate function from react-router, use it (faster)
  if (navigate) {
    navigate("/login", { replace: true });
  } else {
    // Fallback: Force a hard reload to the login page
    window.location.href = "/login";
  }
};